import React, { FC, useEffect } from 'react'
import { Form, Input } from 'antd'
import { AddressType, DecryptedAddress, DecryptedTelecom, HealthcareParty, TelecomType } from '@icure/cardinal-sdk'
import { FormInstance } from 'antd/es/form/hooks/useForm'

import '../index.less'
import { useCreateOrUpdatePractitionerMutation, useGetPractitionerQuery } from '../../../../core/api/practitionerApi'
import { SpinLoader } from '../../../common/SpinLoader'
import { skipToken } from '@reduxjs/toolkit/query'

interface GeneralInfoProps {
  practitionerId?: string
  form: FormInstance
  onClose: () => void
  t: (key: string, ctxt?: { [key: string]: string }) => string
}

export const GeneralInfo: FC<GeneralInfoProps> = ({ practitionerId, form, onClose, t }) => {
  const { data: practitioner, isFetching: isPractitionerFetching } = useGetPractitionerQuery(practitionerId ?? skipToken, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  })

  const [updatePractitioner, { isSuccess: isPractitionerUpdatedSuccessfully, isLoading: isPractitionerUpdatingLoading }] = useCreateOrUpdatePractitionerMutation()

  useEffect(() => {
    if (isPractitionerUpdatedSuccessfully) {
      onClose()
    }
  }, [isPractitionerUpdatedSuccessfully])

  const practitionerEmail = practitioner?.addresses[0].telecoms.find((item) => item.telecomType === TelecomType.Email)?.telecomNumber

  const handleSubmit = (value: { firstName: string; lastName: string; emailAddress: string }) => {
    const { firstName, lastName, emailAddress } = value
    const address = new DecryptedAddress({
      addressType: AddressType.Home,
      telecoms: [
        new DecryptedTelecom({
          telecomType: TelecomType.Email,
          telecomNumber: emailAddress,
        }),
      ],
    })

    updatePractitioner(
      new HealthcareParty({
        ...practitioner,
        firstName,
        lastName,
        addresses: [address],
      }),
    )
    form.resetFields()
  }

  return (
    <>
      {(isPractitionerUpdatingLoading || isPractitionerFetching) && <SpinLoader />}
      <Form
        className="modalManageAccountForm__form"
        layout="vertical"
        onFinish={(values) => handleSubmit(values)}
        colon={false}
        form={form}
        initialValues={{
          emailAddress: practitionerEmail,
          firstName: practitioner?.firstName,
          lastName: practitioner?.lastName,
        }}
      >
        <div className="modalManageAccountForm__form__inputs">
          <Form.Item
            name="firstName"
            label={t('modalManageAccountForm.general.firstName')}
            rules={[{ required: true, message: t('modalManageAccountForm.general.firstNameIsRequired') }]}
          >
            <Input placeholder={t('modalManageAccountForm.general.firstName')} size="large" />
          </Form.Item>
          <Form.Item
            name="lastName"
            label={t('modalManageAccountForm.general.lastName')}
            rules={[{ required: true, message: t('modalManageAccountForm.general.lastNameIsRequired') }]}
          >
            <Input placeholder={t('modalManageAccountForm.general.lastName')} size="large" />
          </Form.Item>
          <Form.Item
            name="emailAddress"
            label={t('modalManageAccountForm.general.emailAddress')}
            rules={[{ required: true, message: t('modalManageAccountForm.general.emailAddressIsRequired') }]}
          >
            <Input placeholder={t('modalManageAccountForm.general.emailAddress')} size="large" />
          </Form.Item>
        </div>
      </Form>
    </>
  )
}
